'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINTS = undefined;
exports.styleToString = styleToString;
exports.insertStylesheet = insertStylesheet;
exports.insertComponentStylesheet = insertComponentStylesheet;
exports.insertProjectStylesheet = insertProjectStylesheet;
exports.validateProjectStylesheet = validateProjectStylesheet;
exports.awaitStylesheet = awaitStylesheet;
exports.prependStylesheet = prependStylesheet;
exports.prependBoilerplateStylesheet = prependBoilerplateStylesheet;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BREAKPOINTS = exports.BREAKPOINTS = {
  desktop: '@media only screen and (min-width: 401px)',
  mobile: '@media only screen and (max-width: 400px)'
};

function styleToString(style, className) {
  var rule = function rule(style, className) {
    var formattedValue = function formattedValue(val) {
      return _lodash2.default.isNumber(val) ? val + 'px' : val;
    };

    var cssString = _lodash2.default.reduce(style, function (result, styleValue, styleProperty) {
      return '' + result + _lodash2.default.kebabCase(styleProperty) + ': ' + formattedValue(styleValue) + '; ';
    }, '');

    return '.' + className + ' { ' + cssString + ' }';
  };

  var rules = [];

  if (_lodash2.default.has(style, 'breakpoints')) {
    rules = _lodash2.default.concat(rules, _lodash2.default.map(style.breakpoints, function (breakpointStyle, breakpoint) {
      var breakpointRules = styleToString(breakpointStyle, className);
      return _lodash2.default.map(breakpointRules, function (breakpointRule) {
        return BREAKPOINTS[breakpoint] + ' { ' + breakpointRule + ' }';
      });
    }));
  }

  var pseudoselectorKeys = _lodash2.default.filter(_lodash2.default.keys(style), function (key) {
    return _lodash2.default.startsWith(key, ':');
  });

  var pseudoselectors = _lodash2.default.pick(style, pseudoselectorKeys);

  rules = _lodash2.default.concat(rules, _lodash2.default.map(pseudoselectors, function (psStyle, ps) {
    return rule(psStyle, className + ps);
  }));

  var base = _lodash2.default.omit(style, 'breakpoints', pseudoselectorKeys);

  rules = _lodash2.default.concat(rules, rule(base, className));
  return rules;
}

function insertStylesheet(href, id) {
  var stylesheet = document.createElement('link');
  stylesheet.setAttribute('id', id);
  stylesheet.setAttribute('rel', 'stylesheet');
  stylesheet.setAttribute('type', 'text/css');
  stylesheet.setAttribute('href', href);
  stylesheet.setAttribute('crossOrigin', 'anonymous');
  document.head.appendChild(stylesheet);
  return stylesheet;
}

function insertComponentStylesheet(componentIds, getStylesheetUrl) {
  return insertStylesheet(getStylesheetUrl({
    cIds: componentIds,
    format: 'css'
  }), _lodash2.default.join(componentIds, '-'));
}

function insertProjectStylesheet(projectIds, getStylesheetUrl) {
  _lodash2.default.forEach(projectIds, function (projectId) {
    return insertStylesheet(getStylesheetUrl({
      pId: projectId
    }), projectId);
  });
} // Block on stylesheets and invalidate stale cache


function validateProjectStylesheet(projects, getStylesheetUrl, draft) {
  // Validate each projects css in parallel
  return Promise.all(_lodash2.default.map(projects, function (project) {
    // If we're dealing with draft, just wait for css to be parsed and do not validate cache
    if (draft) {
      return new Promise(function (resolve) {
        awaitStylesheet(project.id, resolve);
      });
    }

    var stylesheet = getStylesheetUrl({
      pId: project.id
    });
    var expectedToExpireAt = new Date(project.cacheExpiresAt || 'Invalid date'); // request stylesheet via fetch to read its headers
    // this also acts as a way to wait on stylesheets to be loaded before rendering

    return window.fetch(stylesheet).then(function (response) {
      // Ensure that both project and css file have expiration date set
      var expiresAt = new Date(response.headers.get('Expires') || 'Invalid date');

      if (String(expiresAt).indexOf('Invalid') > -1 || String(expectedToExpireAt).indexOf('Invalid') > -1) {
        return false;
      } // If expiration date is roughly 2 seconds away from expected it's up to date
      // The slack is to account for lossy millisecond precision when formatting timestamps


      if (Math.abs(+expiresAt - +expectedToExpireAt) < 2000) {
        return false;
      } // Bust the cache


      return window.fetch(stylesheet, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Cache-Control': 'no-cache'
        }
      }).then(function () {
        // Reinitialize css
        var link = document.querySelector('link[id="' + project.id + '"]');

        if (link) {
          link.removeAttribute('href');
          return new Promise(function (resolve) {
            window.requestAnimationFrame(function () {
              link.setAttribute('href', stylesheet);
              window.requestAnimationFrame(resolve);
            });
          });
        }

        return true;
      });
    }, {
      method: 'GET',
      mode: 'cors'
    }) // Ensure stylesheet is parsed
    .then(function () {
      return new Promise(function (resolve) {
        awaitStylesheet(project.id, resolve);
      });
    }) // Ignore exceptions, render it anyway
    .catch(function (e) {
      return console.warn(e);
    });
  }));
} // Check until stylesheet was fully parsed


function awaitStylesheet(id, onLoad) {
  var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var stylesheet = document.querySelector('link[id="' + id + '"]');
  var ss = document.styleSheets;

  for (var i = 0, max = ss.length; i < max; i += 1) {
    if (ss[i].href === stylesheet.href) {
      return onLoad();
    }
  } // poll stylesheet 5 each 100ms times before giving up and firing onLoad


  if (attempt > 5) {
    onLoad();
  } else {
    setTimeout(function () {
      awaitStylesheet(id, onLoad, attempt + 1);
    }, 100);
  }

  return null;
}

function prependStylesheet(id, link) {
  var stylesheet = document.createElement('link');
  stylesheet.setAttribute('id', id);
  stylesheet.setAttribute('rel', 'stylesheet');
  stylesheet.setAttribute('href', link);
  document.head.insertBefore(stylesheet, document.head.firstChild);
}

function prependBoilerplateStylesheet() {
  if (!document.querySelector('#mason-css-boilerplate')) {
    prependStylesheet('mason-css-boilerplate', 'https://s3-us-west-1.amazonaws.com/static-trymason-com/baseline.css');
  }
}